<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
    name: 'ProDownload'
}
</script>

<style>

</style>